import { connect } from 'react-redux';

import { setNewlyCreatedTeam } from '../redux/actions';

import { CreateTeam } from './CreateTeam';

const mapStateToProps = (state) => ({
  editTeamInfo: state.teamsReduxReducer.editTeamInfo,
});

const mapDispatchToProps = {
  setNewlyCreatedTeam,
};

export default connect(mapStateToProps, mapDispatchToProps)(CreateTeam);
